import JSEncrypt from "../utils/jsencrypt.min.js";
import moment from "moment";
import routes from "../router/index.js";
import { isEmpty } from "xe-utils";

export const __FUNC__ = {
  randomData: function (min, max) {
    if (max == undefined) {
      if (min == undefined) min = 10;
      min = parseInt(min);
      return Math.round(Math.random() * min);
    } else {
      min = parseInt(min);
      max = parseInt(max);
      return min + Math.round((max - min) * Math.random());
    }
  },
  //查出左侧菜单列表，需要传入routes和当前路由路径的字符串
  findSideMenu(routes, path) {
    //处理path，保持格式一致
    if (path.charAt(0) == "/") {
      path = path.substring(1);
    }

    let idx = path.indexOf("/");
    if (idx == -1) return routes;

    let keyword = path.slice(0, idx); //path中当前查找的那一级字符串
    let pathStr = "", //还没有进行查询的path字符串
      obj = {}; //接收当前查到的这一级

    obj = routes.find((item) => {
      return item.path.indexOf(keyword) > -1;
    });
    pathStr = path.substring(idx);
    if (obj?.children) {
      return this.findSideMenu(obj.children, pathStr);
    } else {
      return [];
    }
  },
  //sum分解为times个随机数（简称红包算法）
  getSumToMoreRandomData: function (sum, times) {
    var res = [];
    if (times === 1) {
      res.push(sum);
      return res;
    }
    var max = (sum / times) * 2;
    var current = 1 + ~~(Math.random() * max - 1);
    res.push(current);
    return res.concat(__FUNC__.getSumToMoreRandomData(sum - current, --times));
  },
  keepDecimal: function (val, num) {
    if (num == undefined) num = 1;
    var pow = Math.pow(10, num);
    var rtn = Math.round(val * pow) / pow;
    return rtn;
  },
  /*
   * 通用性：通用
   * 方法说明：动态生成表单提交
   * 参数说明：url：提交地址；obj：需要提交的参数；target：页面如何呈现；method：表单提交方式
   */
  openPostWindow: function (url, obj, target, method) {
    var tempForm = document.createElement("form");
    // if (obj.csrfmiddlewaretoken == undefined) {
    //     obj.csrfmiddlewaretoken = $.cookie("csrftoken")
    // }
    tempForm.id = "tempForm1";
    tempForm.method = method == undefined ? "get" : method;
    tempForm.action = url;
    tempForm.target = target == undefined ? "_self" : target; //打开新页面
    for (var i in obj) {
      var hideInput = document.createElement("input");
      hideInput.type = "hidden";
      hideInput.name = i; //后台要接收这个参数来取值
      hideInput.value = obj[i]; //后台实际取到的值
      tempForm.appendChild(hideInput);
    }
    if (document.all) {
      tempForm.attachEvent("onsubmit", function () {}); //IE
    } else {
      var subObj = tempForm.addEventListener("submit", function () {}, false); //firefox
    }
    document.body.appendChild(tempForm);
    if (document.all) {
      tempForm.fireEvent("onsubmit");
    } else {
      var evt = document.createEvent("HTMLEvents");
      evt.initEvent("submit", false, false);
      tempForm.dispatchEvent(evt);
    }
    tempForm.submit();
    document.body.removeChild(tempForm);
  },
  //十六进制颜色转rgba，只接收#xxx或者#xxxxxx
  hex2Rgba: function (color, opacity) {
    var reg_hex = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
    var sColor = color.toLowerCase();
    if (sColor && reg_hex.test(sColor)) {
      if (sColor.length === 4) {
        var nColor = "#";
        for (var i = 1; i < 4; i++) {
          nColor += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
        }
        sColor = nColor;
      }
      var sColorArr = [];
      for (var i = 1; i < 7; i += 2) {
        sColorArr.push(parseInt("0x" + sColor.slice(i, i + 2)));
      }
      return (
        "rgba(" +
        sColorArr.join(",") +
        "," +
        (opacity ? parseFloat(opacity) : 1) +
        ")"
      );
    } else {
      return sColor;
    }
  },
  //html转码
  htmlEncode: function (str) {
    var s = "";
    if (str.length == 0) return "";
    s = str.replace(/&/g, "&amp;");
    s = s.replace(/</g, "&lt;");
    s = s.replace(/>/g, "&gt;");
    s = s.replace(/ /g, "&nbsp;");
    s = s.replace(/\'/g, "&#39;");
    s = s.replace(/\"/g, "&quot;");
    //...
    return s;
  },
  //html解码
  htmlDecode: function (str) {
    var s = "";
    if (str.length == 0) return "";
    s = str.replace(/&amp;/g, "&");
    s = s.replace(/&lt;/g, "<");
    s = s.replace(/&gt;/g, ">");
    s = s.replace(/&nbsp;/g, " ");
    s = s.replace(/&#39;/g, "'");
    s = s.replace(/&quot;/g, '"');
    //...
    return s;
  },
  //深度合并两个对象
  deepMergeObject: function (FirstOBJ, SecondOBJ) {
    // 深度合并对象
    for (var key in SecondOBJ) {
      FirstOBJ[key] =
        FirstOBJ[key] && FirstOBJ[key].toString() === "[object Object]"
          ? __FUNC__.deepMergeObject(FirstOBJ[key], SecondOBJ[key])
          : (FirstOBJ[key] = SecondOBJ[key]);
    }
    return FirstOBJ;
  },
  //深度查找节点，返回true / false
  findTarget(obj, target, key) {
    if (!key) key = "name";
    for (const index in obj) {
      const element = obj[index];
      if (element[key] == target) {
        return true;
      }
      if (element.children && element.children.length) {
        if (this.findTarget(element.children, target, key)) {
          return true;
        }
      }
    }
  },
  //设置存储
  setLocalStorage(key, value) {
    window.localStorage.setItem(key, value);
    return value;
  },
  //获取存储
  getLocalStorage(key) {
    return window.localStorage.getItem(key);
  },
  // 密码加密
  rsaEncryptedData: function (data) {
    let jsencrypt = new JSEncrypt();
    jsencrypt.setPublicKey(data.public_key);
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    var result = jsencrypt.encrypt(data.password.toString());
    return result;
  },
  //匹配权限菜单
  getAuthMenus: function (authRouters = [], allRouters = []) {
    var realRoutes = [];
    allRouters.forEach((v, i) => {
      authRouters.forEach((w, j) => {
        if (w.name === v.name) {
          if (w.children && w.children.length > 0) {
            v.children = this.getAuthMenus(w.children, v.children);
          }
          realRoutes.push(v);
        }
      });
    });
    return realRoutes;
  },
  //image file转base64
  fileToBase64(file, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(file);
  },
  //base64转文件流
  base64toFile(dataurl, filename) {
    let arr = dataurl.split(",");
    let mime = arr[0].match(/:(.*?);/)[1];
    let suffix = mime.split("/")[1];
    let bstr = window.atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], `${filename}.${suffix}`, {
      type: mime,
    });
  },
  //blob下载
  blobToFile(content, filename = "file.xlsx") {
    const blob = new Blob([content]),
      a = document.createElement("a"),
      url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  },
  //文件新开页签下载
  downloadFileInNewTab(url, params) {
    Object.keys(params).forEach((key, i) => {
      let _symbol = i == 0 ? "?" : "&";
      url += `${_symbol}${key}=${params[key]}`;
    });
    window.open(url, "_balnk");
  },
  //搜索结果存储   newValue 搜索值  maxLength 搜索结果数量
  insertSearchWord: function (newValue, maxLength = 10) {
    const searchList = JSON.parse(
      localStorage.getItem("global_search_list") || "[]"
    );
    const newValueIndex = searchList.findIndex((item) => item === newValue);
    if (newValueIndex === 0) {
      return;
    }
    if (newValueIndex > 0) {
      searchList.splice(newValueIndex, 1); //删掉这个数
    }
    searchList.unshift(newValue); //把这条数据存储到数组中的第一个位置上
    if (searchList.length > maxLength) {
      searchList.splice(maxLength);
    }
    localStorage.setItem("global_search_list", JSON.stringify(searchList));
    return searchList;
  },
  //判断是否是图片
  isImageByName: function (
    filename,
    acceptTypes = ["jpg", "png", "bmp", "gif", "jpeg", "webp"]
  ) {
    if (!filename) return false;
    let _suffix = filename.substr(filename.lastIndexOf(".") + 1).toLowerCase();
    return acceptTypes.includes(_suffix);
  },
  //数字转换为大写金额x
  digitUppercase(n = 0) {
    if (n === "" || isNaN(n) || typeof Number(n) !== "number") {
      return "";
    }
    let fraction = ["角", "分"];
    let digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
    let unit = [
      ["元", "万", "亿"],
      ["", "拾", "佰", "仟"],
    ];
    let head = n < 0 ? "欠" : "";
    if (n === "" || n === "-") {
      return "";
    }

    n = Math.abs(n);
    let s = "";
    for (let i = 0; i < fraction.length; i++) {
      s += (
        digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]
      ).replace(/零./, "");
    }
    s = s || "整";
    n = Math.floor(n);
    for (let i = 0; i < unit[0].length && n > 0; i++) {
      let p = "";
      for (let j = 0; j < unit[1].length && n > 0; j++) {
        p = digit[n % 10] + unit[1][j] + p;
        n = Math.floor(n / 10);
      }
      s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][i] + s;
    }
    return (
      head +
      s
        .replace(/(零.)*零元/, "元")
        .replace(/(零.)+/g, "零")
        .replace(/^整$/, "零元整")
    );
  },
  // 默认值数据联动返回
  dataLinkage({ params, id, value, selectedOptions, radioOptions }) {
    if (id === params.id) {
      if (
        ["input", "number", "multiinput", "phone", "certificates"].includes(
          params.type
        )
      ) {
        let ldzd_tj = params.condition[0].ldzd_tj,
          ldzd_value = params.condition[0].ldzd_value,
          dqzd_value = params.condition[0].dqzd_value,
          _value = params.condition[0].dqzd_tj === "form" ? value : dqzd_value;

        if (ldzd_tj === "eq" && Number(value) === Number(ldzd_value)) {
          return _value;
        } else if (ldzd_tj === "neq" && value !== ldzd_value) {
          return _value;
        } else if (ldzd_tj === "iscon" && value.indexOf(ldzd_value) !== -1) {
          return _value;
        } else if (ldzd_tj === "niscon" && value.indexOf(ldzd_value) == -1) {
          return _value;
        } else if (ldzd_tj === "isnull" && value.trim() === "") {
          return _value;
        } else if (ldzd_tj === "nisnull" && value !== "") {
          return _value;
        } else if (ldzd_tj === "gte" && Number(value) >= Number(ldzd_value)) {
          return _value;
        } else if (ldzd_tj === "lte" && Number(value) <= Number(ldzd_value)) {
          return _value;
        } else {
          return "";
        }
      } else if (params.type == "select" && selectedOptions) {
        let item = params.condition.filter(
          (item) => item.xx_id === selectedOptions.key
        );
        if (item.length !== 0) {
          return item[0].dqzd_tj === "form"
            ? selectedOptions.value || selectedOptions.dyz
            : item[0].dqzd_value;
        } else {
          return "";
        }
      } else if (params.type == "radio" && radioOptions) {
        let item = params.condition.filter(
          (item) => item.xx_id === radioOptions.key
        )[0];

        return item.dqzd_tj === "form" ? radioOptions.value : item.dqzd_value;
      } else if (params.type === "date") {
        let ldzd_tj = params.condition[0].ldzd_tj,
          ldzd_value = params.condition[0].ldzd_value,
          dqzd_value = params.condition[0].dqzd_value,
          timeStamp = moment(value).unix(),
          _value = params.condition[0].dqzd_tj === "form" ? value : dqzd_value;
        console.log(ldzd_tj);
        console.log(timeStamp, "timeStamp");
        console.log(moment(ldzd_value).unix(), "77");

        if (ldzd_tj === "eq" && timeStamp === moment(ldzd_value).unix()) {
          return _value;
        } else if (
          ldzd_tj === "neq" &&
          timeStamp !== moment(ldzd_value).unix()
        ) {
          return _value;
        } else if (
          ldzd_tj === "gte" &&
          timeStamp >= moment(ldzd_value).unix()
        ) {
          return _value;
        } else if (
          ldzd_tj === "lte" &&
          timeStamp <= moment(ldzd_value).unix()
        ) {
          return _value;
        } else if (ldzd_tj === "isnull" && timeStamp === "") {
          return _value;
        } else if (ldzd_tj === "nisnull" && timeStamp !== "") {
          return _value;
        } else if (ldzd_tj === "range") {
          let arr = ldzd_value.split("至");
          if (
            timeStamp >= moment(arr[0]).unix() &&
            timeStamp <= moment(arr[1]).unix()
          ) {
            return _value;
          } else {
            return "";
          }
        } else {
          return "";
        }
      } else {
        return "";
      }
    } else {
      return false;
    }
  },
  // 打乱数组
  shuffle(arr) {
    var length = arr.length,
      randomIndex,
      temp;
    while (length) {
      randomIndex = Math.floor(Math.random() * length--);
      temp = arr[randomIndex];
      arr[randomIndex] = arr[length];
      arr[length] = temp;
    }
    return arr;
  },

  /**
   * 获取会话服务器地址
   * @param {string} api 接口请求地址 以/开头
   */
  getwshref(api) {
    let protocol = "ws",
      url = "";
    if (window.location.protocol == "https:") {
      protocol = "wss";
    }
    url = `${protocol}://${window.location.host}${api}`;
    return url;
  },
  // 获取动态权限路由
  getAuthRoutes(info) {
    //存储用户菜单
    let authRoutes = [];
    const loopMenu = (data) => {
      data.forEach((menu) => {
        if (menu.relationRoutes?.length) {
          authRoutes.push(...menu.relationRoutes);
        }
        if (menu.children?.length) {
          loopMenu(menu.children);
        }
      });
    };
    let homeUrl = info.index_url != "" ? info.index_url.split("/") : [];
    // 获取首页name
    let homeName = "";
    if (homeUrl.length) {
      homeName = homeUrl[homeUrl.length - 1];
      let web = info.web.filter(
        (v) => v.path !== "webHome" && v.path !== "home"
      );
      // 生成对应首页的路由数组
      let home_routes = routes.options.routes
        .filter((v) => v.path === "/web")[0]
        .children.filter((v) => v.name === homeName);
      // 删除原来的首页从新建立首页
      web.unshift({
        children: [],
        meta: { title: "首页" },
        name: "webHome",
        path: "webHome",
        redirect: "webHome",
        relationRoutes: this.getNameFromChildren(home_routes), //获取动态路由
      });
      loopMenu(web);
    } else {
      loopMenu(info.web);
    }
    return authRoutes;
  },
  // 递归取出所有的children里的name
  getNameFromChildren(data, arr = []) {
    data.map((v) => {
      arr.push(v.name);
      if (v.children && v.children.length) {
        this.getNameFromChildren(v.children, arr);
      }
    });
    return arr;
  },
  // 动态获取头部菜单
  getAuthHeadNav(info) {
    // 首页url
    let homeUrl = info.index_url != "" ? info.index_url.split("/") : [];
    // 获取首页name
    let homeName = "";
    if (homeUrl.length) {
      homeName = homeUrl[homeUrl.length - 1];
      let web = info.web.filter(
        (v) => v.path !== "webHome" && v.path !== "home"
      );
      // 生成对应首页的路由数组
      let home_routes = routes.options.routes
        .filter((v) => v.path === "/web")[0]
        .children.filter((v) => v.name === homeName);
      // 删除原来的首页从新建立首页

      web.unshift(home_routes[0]);
      return web.map((v) => v.name);
    } else {
      return info.web.map((v) => v.name);
    }
  },
  /**
   * 首字母转小写
   * @param {String} str 待格式化的字符串
   * @param {String} char 分隔符
   * @returns
   */
  lowFirstLetter(str, char) {
    char = char ?? "-";
    //其中 slice(0, 1) 可以替换为charAt(0)
    return str
      .split(char)
      .map((val) => val.slice(0, 1).toLowerCase() + val.slice(1))
      .join("");
  },
  /**
   * 首字母转大写
   * @param {String} str 待格式化的字符串
   * @param {String} char 分隔符
   * @returns
   */
  upperFirstLetter(str, char) {
    char = char ?? "-";
    //其中 slice(0, 1) 可以替换为charAt(0)
    return str
      .split(char)
      .map((val) => val.slice(0, 1).toUpperCase() + val.slice(1))
      .join("");
  },
  /**
   * 字符串切割为数组
   * @param {*} str 字符串
   * @param {*} char 分隔符
   * @returns
   */
  arrayByChar(str, char) {
    char = char ?? /(?=[A-Z])/; //默认按照大写字母分隔
    let arr = str.split(char);
    return arr;
  },
  /**
   * 姓名脱敏
   * @param {string} name  姓名
   * @return {string} 显示姓名中的第一个字，其它用*号代替
   */
  desensitizeName(name) {
    if (!name) {
      return name;
    }
    return name.replace(/(^.{1})(.+)$/g, (...args) => {
      let tempStr = "";
      if (args[2] && args[2].length) {
        tempStr = Array.from({
          length: args[2].length + 1,
        }).join("*");
      }
      return args[1] + tempStr;
    });
  },
};
